module.exports = __webpack_public_path__ + "static/media/imgIdea.113d1095.svg";